import React from 'react';
import { Slider } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { FRESHNESS_MONTHS, FRESH_PERCENT_STEP, formatMonths } from './freshness';

// Шкала качества: реальные значения score доходят до ~500.
const SCORE_MAX = 500;
const SCORE_STEP = 10;

const RatingSidebar = ({ filters, onFilterChange }) => {
  const intl = useIntl();
  const handleChange = (e) => {
    const { name, value } = e.target;
    onFilterChange({ ...filters, [name]: value });
  };

  const ageMonths = Number(filters.ageMonths) || FRESHNESS_MONTHS;
  const minFreshPercent = Number(filters.minFreshPercent) || 0;

  const scoreRange = [
    Number(filters.minScore) || 0,
    Number(filters.maxScore) || SCORE_MAX,
  ];

  const handleScoreChange = ([minScore, maxScore]) => {
    onFilterChange({ ...filters, minScore, maxScore });
  };

  return (
    <div className="sidebar-filters">
      <h3><FormattedMessage id="rating.filters.title" defaultMessage="Filters" /></h3>

      <div className="filter-group">
        <label><FormattedMessage id="rating.filters.keyword" defaultMessage="Keyword" /></label>
        <input
          type="text"
          name="keyword"
          value={filters.keyword}
          onChange={handleChange}
          placeholder={intl.formatMessage({ id: "rating.filters.keywordPlaceholder", defaultMessage: "Search requests..." })}
        />
      </div>

      <div className="filter-group">
        <label><FormattedMessage id="rating.filters.contentType" defaultMessage="Content Type" /></label>
        <select name="contentType" value={filters.contentType} onChange={handleChange}>
          {/* Пустое значение — «не фильтровать по типу», сюда попадает всё, включая видео и
              музыку. 'Images' — реальный contentType в БД: фото+иллюстрации+векторы вместе. */}
          <option value="">{intl.formatMessage({ id: "rating.filters.allTypes", defaultMessage: "All Types" })}</option>
          <option value="Images">{intl.formatMessage({ id: "rating.filters.allImages", defaultMessage: "All images" })}</option>
          <option value="Photos">{intl.formatMessage({ id: "rating.filters.photos", defaultMessage: "Photos" })}</option>
          <option value="Illustrations">{intl.formatMessage({ id: "rating.filters.illustrations", defaultMessage: "Illustrations" })}</option>
          <option value="Vectors">{intl.formatMessage({ id: "rating.filters.vectors", defaultMessage: "Vectors" })}</option>
          {/* Значения должны совпадать с contentType из SPECIAL_CONTENT_TYPE_PAGES в
              KeyHunter/src/components/adobe/adobe.jsx — бэкенд сравнивает строку как есть. */}
          <option value="Video">{intl.formatMessage({ id: "rating.filters.video", defaultMessage: "Video" })}</option>
          <option value="Templates">{intl.formatMessage({ id: "rating.filters.templates", defaultMessage: "Templates" })}</option>
          <option value="3D">{intl.formatMessage({ id: "rating.filters.3d", defaultMessage: "3D" })}</option>
          <option value="Audio">{intl.formatMessage({ id: "rating.filters.audio", defaultMessage: "Music" })}</option>
        </select>
      </div>

      <div className="filter-group">
        {/* Обе границы качества — одним компонентом, что и возраст, ради единого вида */}
        <label><FormattedMessage id="rating.filters.quality" defaultMessage="Quality" /> ({scoreRange[0]} – {scoreRange[1]})</label>
        <Slider
          range
          min={0}
          max={SCORE_MAX}
          step={SCORE_STEP}
          value={scoreRange}
          onChange={handleScoreChange}
        />
      </div>

      {/* Свежесть выдачи — два органа управления, потому что вопрос двусоставной: за какой срок
          считать «свежим» и сколько таких работ должно быть. Одним ползунком это не задаётся. */}
      <div className="filter-group">
        <label>
          <FormattedMessage id="rating.filters.freshMonths" defaultMessage="Fresh within" />
          {' '}({formatMonths(ageMonths)})
        </label>
        <Slider
          min={1}
          max={FRESHNESS_MONTHS}
          step={1}
          value={ageMonths}
          onChange={(value) => onFilterChange({ ...filters, ageMonths: value })}
          tooltip={{ formatter: formatMonths }}
        />
      </div>

      <div className="filter-group">
        {/* 0 = фильтр выключен, так и подписываем: иначе «0%» читается как условие, хотя
            под него подходит вообще всё. */}
        <label>
          <FormattedMessage id="rating.filters.freshShare" defaultMessage="Share of fresh works" />
          {' '}({minFreshPercent
            ? `≥ ${minFreshPercent}%`
            : intl.formatMessage({ id: "rating.filters.any", defaultMessage: "Any" })})
        </label>
        <Slider
          min={0}
          max={100}
          step={FRESH_PERCENT_STEP}
          value={minFreshPercent}
          onChange={(value) => onFilterChange({ ...filters, minFreshPercent: value })}
          tooltip={{ formatter: (value) => `${value}%` }}
        />
      </div>
    </div>
  );
};

export default RatingSidebar;
